import { TABS } from './constants.js';
import cls from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { GlobalContext } from 'wix-rich-content-common';
import { FocusManager, SettingsMobileHeader, SettingsPanelHeader, Tabs, Tab, SettingsPanelFooter } from 'wix-rich-content-ui-components';
import { POLLS_SETTINGS_MODAL } from '../../dataHooks.js';
import PollViewer from '../../viewer/poll-viewer.js';
import { RCEHelpersContext } from '../rce-helpers-context/index.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { EditPollSection } from './edit-poll-section/EditPollSection.js';
import { LayoutSettingsSection } from './layout-settings-section/LayoutSettingsSection.js';
import { DesignSettingsSection } from './design-settings-section/DesignSettingsSection.js';
import { PollSettingsSection } from './poll-settings-section/PollSettingsSection.js';
import { PollContextProvider } from '../poll-context/PollContext.js';
import 'ricos-context';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import '../../viewer/poll-component.js';
import 'react-flip-move';
import 'react-measure';
import '../poll-option/index.js';
import '../../defaults-0542c304.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../../RemoveOption-0fb59667.js';
import '../../assets/icons/RemoveIcon.js';
import '../poll-option/PollOptionBase.js';
import '../poll-option/types.js';
import '../poll-context/types.js';
import '../../assets/icons/NonEditableIcon.js';
import '../../assets/icons/CheckIcon.js';
import '../image-upload/ImageUpload.js';
import '../image-upload/types.js';
import '../../assets/icons/LoaderIcon.js';
import '../../assets/icons/ReplaceIcon.js';
import '../text-field/TextField.js';
import 'lodash';
import '../poll-option/PollListOption.js';
import '../poll-option/webview/PollListOptionWebview.js';
import '../../option-webview-c29b68a5.js';
import '../poll-option/webview/PollGridOptionWebview.js';
import '../poll-header/PollHeader.js';
import '../voted-users/VotedUsers.js';
import '../voted-users/types.js';
import '../../VotedUsersModal-b3691022.js';
import 'react-infinite-scroller';
import '../voted-users/VoterAvatar.js';
import '../voted-users/FallbackAvatar.js';
import '../../assets/icons/AddIcon.js';
import 'wix-rich-content-plugin-commons';
import '../../assets/icons/LayoutListIcon.js';
import '../../assets/icons/LayoutGridIcon.js';
import '../../assets/icons/ColorIcon.js';
import '../../assets/icons/GradientIcon.js';
import '../../assets/icons/ImageIcon.js';

var css_248z = "[dir=ltr] .WUaSt{text-align:left}[dir=rtl] .WUaSt{text-align:right}[dir] .HC6mO{border-bottom:1px solid #ededed;padding:0 20px}.HC6mO .NLuub{font-size:20px;line-height:1.4}[dir] .HC6mO .NLuub{margin:25px 0 20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.HC6mO{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .HC6mO{padding:20px}}}@container (width < 640px){.HC6mO{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .HC6mO{padding:20px}}._6Nf2P{height:auto;overflow:hidden}._3-h9G,._6Nf2P{align-items:center;display:flex}._3-h9G{flex-direction:row;font-family:inherit;font-size:16px;line-height:1;outline:none}[dir] ._3-h9G{background:none;border:0;padding:0}._3-h9G.LcnsP{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}._3-h9G.YXn2-{color:inherit}.wZ33g{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] .wZ33g{padding:24px}.wZ33g *,.wZ33g :after,.wZ33g :before{box-sizing:inherit}.wZ33g input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.wZ33g{height:calc(100% - 100px);top:100px}[dir] .wZ33g{padding:20px}}}@container (width < 640px){.wZ33g{height:calc(100% - 100px);top:100px}[dir] .wZ33g{padding:20px}}.NLuub{color:var(--ricos-settings-text-color,#000);font-size:16px;line-height:1.5}[dir] .NLuub{margin:0 0 15px}._3oM0C{color:var(--ricos-settings-text-color,#000);font-size:14px;line-height:1.43}[dir] ._3oM0C{margin:0 0 5px}.-E3iu,.-bb65,._6pJVx{font-size:14px;line-height:1.43}[dir] .-E3iu,[dir] .-bb65,[dir] ._6pJVx{margin:0 0 5px}[dir] .-bb65{margin:10px 0}._2i3HI{grid-column-gap:10px;grid-template-columns:repeat(3,1fr)}[dir] ._2i3HI{margin:10px 0}.sYDNQ{grid-column-gap:10px;grid-auto-rows:1fr;grid-template-columns:repeat(4,1fr)}[dir] .sYDNQ{margin:20px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.sYDNQ{grid-template-columns:repeat(3,1fr)}}}@container (width < 640px){.sYDNQ{grid-template-columns:repeat(3,1fr)}}.CyYE5{align-items:center;display:flex;flex-direction:row;gap:5px}[dir] .CyYE5{margin:5px 0}.CyYE5._4Vm9-{align-items:start;display:flex;flex-direction:column}[dir] .CyYE5._4Vm9-{margin:10px 0 20px}.xzAS8{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:auto}[dir] .xzAS8{margin:0;padding-top:10px}[dir] .NJQq8{margin:5px 0}[dir] .xzAS8:hover:not(.rsgQU){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] .rsgQU{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.rsgQU *{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .Ku66P{cursor:pointer;margin:15px 0;padding:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .Ku66P{padding-top:0!important}}}@container (width < 640px){[dir] .Ku66P{padding-top:0!important}}.ujAwR{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;justify-content:center;width:80%}[dir] .ujAwR{background:transparent}.RYvFy{align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;position:fixed;top:0;z-index:8}[dir] .RYvFy{background-color:rgba(0,0,0,.6);cursor:auto}[dir=ltr] .RYvFy,[dir=rtl] .RYvFy{left:0;right:0}.S9M4J{display:flex;justify-content:flex-end;width:100%}[dir=ltr] .S9M4J{border-right:1px solid #ededed;padding-right:15px}[dir=rtl] .S9M4J{border-left:1px solid #ededed;padding-left:15px}.e-YO-{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] .e-YO-{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.e-YO-{max-width:100%;top:50px}}}@container (width < 640px){.e-YO-{max-width:100%;top:50px}}";
var styles = {"settings_container":"WUaSt","header":"HC6mO","title":"NLuub","header_button_list":"_6Nf2P","poll_header_button":"_3-h9G","poll_header_button_primary":"LcnsP","poll_header_button_secondary":"YXn2-","section":"wZ33g","subtitle":"_3oM0C","sliderWithInput_label":"-bb65","label":"-E3iu","checkbox_label":"_6pJVx","preset_selector":"_2i3HI","layout_selector":"sYDNQ","radioGroup":"CyYE5","radioPanel":"_4Vm9-","selectionListOption":"xzAS8","selectionListOptionLabel":"NJQq8","selectionListOption_selected":"rsgQU","labeled_toggle_root":"Ku66P","modal":"ujAwR","overlay":"RYvFy","preview_button":"S9M4J","poll_tab_headers":"e-YO-"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SettingsModal extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      activeTab: this.props.activeTab,
      componentData: this.props.componentData,
      $container: React.createRef(),
      isPreviewOpen: false
    });
    __publicField(this, "setPoll", (poll) => {
      const { updateData } = this.props;
      updateData({ poll });
    });
    __publicField(this, "handleTabChange", (activeTab) => this.setState({ activeTab }));
    __publicField(this, "getContainer", () => this.state.$container.current);
    __publicField(this, "closePreview", () => this.setState({ isPreviewOpen: false }));
    __publicField(this, "openPreview", () => this.setState({ isPreviewOpen: true }));
    __publicField(this, "onComponentUpdate", () => this.forceUpdate());
  }
  componentDidCatch() {
  }
  render() {
    var _a;
    const { activeTab, $container, isPreviewOpen } = this.state;
    const {
      helpers,
      t,
      isMobile,
      settings,
      updateData,
      onCancel,
      onSave,
      componentData,
      experiments = {}
    } = this.props;
    const languageDir = ((_a = this.props) == null ? void 0 : _a.languageDir) || this.context.languageDir;
    return /* @__PURE__ */ React.createElement("div", { "data-hook": POLLS_SETTINGS_MODAL, ref: $container, className: styles.settings_container }, /* @__PURE__ */ React.createElement(FocusManager, { dir: languageDir }, isMobile ? /* @__PURE__ */ React.createElement(
      SettingsMobileHeader,
      {
        onSave,
        onCancel,
        title: t("Poll_PollSettings_Common_Header"),
        t
      }
    ) : /* @__PURE__ */ React.createElement(SettingsPanelHeader, { title: t("Poll_PollSettings_Common_Header"), onClose: onCancel }), activeTab === TABS.EDIT ? /* @__PURE__ */ React.createElement(
      RCEHelpersContext.Provider,
      {
        value: {
          layout: componentData.layout,
          design: componentData.design,
          helpers,
          t,
          isMobile
        }
      },
      /* @__PURE__ */ React.createElement(
        PollContextProvider,
        {
          settings,
          poll: componentData.poll,
          setPoll: this.setPoll,
          t,
          experiments
        },
        /* @__PURE__ */ React.createElement(
          EditPollSection,
          {
            updateData,
            layout: componentData.layout,
            experiments
          }
        )
      )
    ) : /* @__PURE__ */ React.createElement(
      Tabs,
      {
        value: activeTab,
        headersStyle: styles.poll_tab_headers,
        onTabSelected: this.handleTabChange
      },
      /* @__PURE__ */ React.createElement(Tab, { label: t("Poll_PollSettings_Tab_Layout_TabName"), value: TABS.LAYOUT }, /* @__PURE__ */ React.createElement(
        LayoutSettingsSection,
        {
          updateData,
          componentData,
          t,
          isMobile,
          experiments
        }
      )),
      /* @__PURE__ */ React.createElement(Tab, { label: t("Poll_PollSettings_Tab_Design_TabName"), value: TABS.DESIGN }, /* @__PURE__ */ React.createElement(
        DesignSettingsSection,
        {
          updateData,
          componentData,
          t,
          languageDir,
          experiments
        }
      )),
      /* @__PURE__ */ React.createElement(Tab, { label: t("Poll_PollSettings_Tab_Settings_TabName"), value: TABS.SETTINGS }, /* @__PURE__ */ React.createElement(
        PollSettingsSection,
        {
          updateData,
          componentData,
          t,
          settings,
          experiments,
          languageDir
        }
      ))
    ), !isMobile && /* @__PURE__ */ React.createElement(SettingsPanelFooter, { fixed: true, cancel: onCancel, save: onSave, t }), isMobile && $container.current && isPreviewOpen && /* @__PURE__ */ React.createElement(
      ReactModal,
      {
        isOpen: isPreviewOpen,
        onRequestClose: this.closePreview,
        parentSelector: this.getContainer,
        className: cls(styles.modal),
        overlayClassName: cls(styles.overlay)
      },
      /* @__PURE__ */ React.createElement(
        PollViewer,
        {
          isMobile: true,
          settings: {
            isPreview: true,
            preventInteraction: true
          },
          componentData,
          onRequestClose: this.closePreview,
          selected: false,
          isViewMode: true
        }
      ),
      "\xA0",
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: cls(styles.poll_header_button, styles.poll_header_button_primary),
          onClick: this.closePreview,
          type: "button"
        },
        t("Poll_Preview_Close_CTA")
      )
    )));
  }
}
__publicField(SettingsModal, "propTypes", {
  activeTab: PropTypes.string.isRequired,
  componentData: PropTypes.object.isRequired,
  helpers: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  t: PropTypes.func,
  relValue: PropTypes.string,
  anchorTarget: PropTypes.string,
  settings: PropTypes.object.isRequired,
  experiments: PropTypes.object,
  updateData: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  languageDir: PropTypes.string
});
__publicField(SettingsModal, "defaultProps", {
  activeTab: TABS.LAYOUT
});
__publicField(SettingsModal, "contextType", GlobalContext);

export { SettingsModal };
//# sourceMappingURL=SettingsModal.js.map
